import { EmployeeCertificatesHeader } from "./components/employee/EmployeeCertificatesHeader";
import { EmployeeCertificatesTable } from "./components/employee/EmployeeCertificatesTable";
import { JSX } from "react";

const CertificatePageContainer = (): JSX.Element => {
    return (
        <>
            <div className="p-certificates">
                <EmployeeCertificatesHeader />
                <EmployeeCertificatesTable />
            </div>
        </>
    );
};

export default CertificatePageContainer;
